<template>
  <div>
    <ts-page-title
      :title="$t('itemIncentiveBonus.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('itemIncentiveBonus.pageTitle'),
          active: true
        }
      ]"
    />
    <ts-card>
      <ts-card-wrapper class="d-flex ts-items-center ts-justify-between">
        <Button type="info" ghost @click="addNew">
          {{ $t('addNew') }}</Button>
        <div class="ts-justify-end ts-space-x-2">
          <ts-input
            v-model="search"
            search
            :placeholder="$t('itemIncentiveBonus.searchBonusItem')"
            style="width: 250px;"
            class="inline-block"
          />
        </div>
      </ts-card-wrapper>
      <Table
        :columns="columns"
        :data="resources"
        size="small"
        :loading="loading"
        max-height="700"
      >
        <template slot-scope="{ row }" slot="custom_keyword">
          {{ row.item_custom_rule ? row.item_custom_rule.custom_rule : '' }}
        </template>
        <template slot-scope="{ row }" slot="is_taxable">
          <span>
            <Icon
              v-if="row.is_taxable"
              type="ios-checkmark text-success"
              size="30"
            />
            <Icon
              v-else
              type="ios-close-circle-outline text-danger"
              size="20"
            />
          </span>
        </template>
        <template slot-scope="{ row }" slot="is_prorate">
                    <span>
                        <Icon
                            v-if="row.is_prorate"
                            type="ios-checkmark text-success"
                            size="30"
                        />
                        <Icon
                            v-else
                            type="ios-close-circle-outline text-danger"
                            size="20"
                        />
                    </span>
                </template>
        <template slot-scope="{ row }" slot="action">
          <a
            href="#"
            class="text-primary"
            @click.prevent="onEdit(row)"
            v-tooltip="$t('edit')"
          >
            <Icon type="ios-create" size="20" />
          </a>
          <Poptip
            confirm
            :title="$t('areYouSure')"
            @on-ok="onDelete(row)"
            :transfer="true"
            :ok-text="$t('yes')"
            :cancel-text="$t('no')"
          >
            <a
              class="text-danger"
              v-tooltip="$t('delete')"
              :disabled="row._deleting"
            >
              <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
              <Icon type="ios-trash" size="20" v-else />
            </a>
          </Poptip>
        </template>
      </Table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('itemIncentiveBonus.pageTitle')"
        centered
        :zIndex="1020"
        :footer="null"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>
<script>
import FromAction from './form.vue'
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'item-incentive-bonus',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      width: 'width: 300px',
      showForm: false
    }
  },
  computed: {
    ...mapState('payroll/itemIncentiveBonus', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.payroll.itemIncentiveBonus.search
      },
      set (newValue) {
        this.$store.commit('payroll/itemIncentiveBonus/SET_SEARCH', newValue)
        this.$store.commit('payroll/itemIncentiveBonus/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          title: this.$t('itemIncentiveBonus.bonusItem'),
          key: 'inc_bonus_item'
        },
        {
          title: this.$t('itemIncentiveBonus.customRule'),
          slot: 'custom_keyword'
        },
        {
          title: this.$t('itemIncentiveBonus.taxable'),
          key: 'is_taxable',
          slot: 'is_taxable'
        },
        {
          title: this.$t('itemIncentiveBonus.prorate'),
          key: 'is_prorate',
          slot: 'is_prorate',
          align: 'center',
        },
        {
          title: this.$t('itemIncentiveBonus.description'),
          key: 'description'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          align: 'center',
          fixed: 'right',
          className: 'tw-space-x-2',
          width: 90
        }
      ]
    }
  },
  methods: {
    addNew () {
      this.showForm = true
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('payroll/itemIncentiveBonus/fetch', attributes)
        .catch(error => {
          this.loading = false
          this.notice({
            type: 'error',
            text: error.message
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onEdit (record) {
      this.showForm = true
      this.$store.commit('payroll/itemIncentiveBonus/SET_EDIT_DATA', record)
    },
    clearEdit () {
      this.showForm = false
      this.$store.commit('payroll/itemIncentiveBonus/SET_EDIT_DATA', {})
    },
    onDelete (record) {
      record._deleting = true
      this.$store
        .dispatch('payroll/itemIncentiveBonus/destroy', record.inc_bonus_id)
        .then(response => {
          this.fetchData()
          record._deleting = false
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
          record._deleting = false
        })
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'ITEM INCENTIVE BONUS',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({
        search
      })
    }, 500)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
